import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[appOutsideClick]',
    standalone: false
})
export class OutsideClickDirective {
  @Output() appOutsideClick = new EventEmitter();

  constructor(private elementRef: ElementRef) { }

  @HostListener('document:click', ['$event'])
  onClick(event: Event): void {
    const target = event.target as Node | null;
    if (!target) return;

    // The click's own handler may have re-rendered the host — a row removed
    // from a *ngFor, an item deleted from a list. By the time this bubbles up to
    // document, that target is detached, so contains() says false and the popup
    // closes on a click that was actually inside it. A target that is no longer
    // in the document was never an outside click.
    if (!document.contains(target)) return;

    if (!this.elementRef.nativeElement.contains(target)) {
      this.appOutsideClick.emit();
    }
  }
}
